module.exports = "/_next/static/images/teacher-3-ff3029dcde166bac7dab0ca63ee2559d.png";